import Vue from 'vue'
import Vuex from 'vuex'
import { firebaseMutations } from 'vuexfire'
import api from '@/api'

import companies from './companies'
import profiles from './profiles'
import products from './products'
import stores from './stores'
import orders from './orders'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  mutations: firebaseMutations,
  strict: debug,
  modules: {
    companies,
    profiles,
    products,
    stores,
    orders
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js